import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { SITE } from "@/lib/siteConfig";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#0A0A0A] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-4">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-red-600 text-white font-display font-black flex items-center justify-center text-sm">
                SOS
              </div>
              <div className="font-display font-black text-xl uppercase tracking-tight">
                Serrurier Express
              </div>
            </div>
            <p className="mt-5 text-slate-400 max-w-sm leading-relaxed">
              Serrurerie d'urgence professionnelle. Intervention rapide, tarif transparent, matériel certifié A2P.
            </p>

            <a
              href={SITE.phoneHref}
              data-testid="call-cta-footer"
              className="mt-6 inline-flex items-center gap-3 bg-red-600 hover:bg-red-700 text-white px-5 py-3 font-display font-bold tracking-tight transition-all"
            >
              <Phone className="w-5 h-5" strokeWidth={2.5} />
              {SITE.phone}
            </a>
          </div>

          <div className="md:col-span-3">
            <div className="text-[11px] uppercase tracking-[0.2em] font-bold text-red-400 mb-4">
              Services
            </div>
            <ul className="space-y-3 text-slate-300 text-sm">
              <li><a href="/depannage-serrurier" className="hover:text-white transition">Dépannage serrurerie</a></li>
              <li><a href="/ouverture-de-porte" className="hover:text-white transition">Ouverture de porte</a></li>
              <li><a href="/blindage-de-porte" className="hover:text-white transition">Blindage</a></li>
              <li><a href="/depannage-coffre-fort" className="hover:text-white transition">Coffre-fort</a></li>
              <li><a href="/installation-serrure-connectee" className="hover:text-white transition">Serrure connectée</a></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="text-[11px] uppercase tracking-[0.2em] font-bold text-red-400 mb-4">
              Contact
            </div>
            <ul className="space-y-3 text-slate-300 text-sm">
              <li className="flex items-start gap-3">
                <Phone className="w-4 h-4 mt-1 text-red-400 flex-shrink-0" />
                <a href={SITE.phoneHref} className="hover:text-white font-semibold">{SITE.phone}</a>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="w-4 h-4 mt-1 text-red-400 flex-shrink-0" />
                <a href={`mailto:${SITE.email}`} className="hover:text-white">{SITE.email}</a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 mt-1 text-red-400 flex-shrink-0" />
                <span>Interventions multi-départements</span>
              </li>
              <li className="flex items-start gap-3">
                <Clock className="w-4 h-4 mt-1 text-red-400 flex-shrink-0" />
                <span>Ouvert 24h/24 · 7j/7</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-xs text-slate-500">
          <div>© {new Date().getFullYear()} SOS Serrurier Express · Tous droits réservés</div>
          <div className="flex gap-6">
            <a href="#" className="hover:text-white">Mentions légales</a>
            <a href="#" className="hover:text-white">Confidentialité</a>
            <a href="#" className="hover:text-white">CGV</a>
          </div>
        </div>

        <div className="mt-4 text-[10px] text-slate-600 leading-relaxed space-y-2">
          <p>
            * Tarifs affichés hors spécificités et pièces détachées. Un devis gratuit vous est systématiquement remis avant toute intervention.
          </p>
          <p>
            Les délais d'intervention sont indicatifs et peuvent varier selon la localisation et le planning des équipes.
          </p>
        </div>
      </div>
    </footer>
  );
}
